import type { CreateUserRequest, LoginAdminResult } from "@/types/generated/UsedGeneratedTypes";

/**
 * Helper pur pour la construction de la requête backend de signature
 * de charte ( endpoint {@code PUT /users} avec champ {@code charte} ) .
 *
 * <p><b>Pourquoi un helper extrait</b> :
 * <ul>
 *   <li><b>SRP</b> : sépare le payload backend de la logique UI Vue
 *       ( computed setter / redirection ) du composant
 *       {@code DetailApplicationModalCard} ;</li>
 *   <li><b>Testabilité</b> : fonction pure , aucune dépendance Vue ,
 *       i18n , localStorage ou réseau ; vérifiable en isolation sur
 *       les cas limites ( stored user null , champs manquants ,
 *       applicationId vide ) ;</li>
 *   <li><b>DRY</b> : tout site qui aurait besoin du même payload
 *       ( ex futur endpoint admin de signature batch ) consomme la
 *       même primitive ;</li>
 *   <li><b>OCP</b> : un nouveau champ {@code CreateUserRequest} se
 *       greffe ici sans modifier les call-sites .</li>
 * </ul>
 *
 * <p><b>Contrat</b> : retourne toujours un {@code CreateUserRequest}
 * valide avec {@code login} et {@code email} en strings ( jamais
 * undefined ) , et {@code charte} = identifiant d'application reçu ,
 * tel quel ( trim non appliqué - responsabilité du caller ) .
 */
export function buildCharteSignRequest(
  storedUser: LoginAdminResult | null | undefined,
  applicationId: string,
): CreateUserRequest {
  return {
    login: storedUser?.login ?? "",
    email: storedUser?.email ?? "",
    charte: applicationId,
  } as CreateUserRequest;
}
